gsap.registerPlugin(ScrollTrigger, SplitText);

function initGsFloatY() {
  const els = gsap.utils.toArray(".gs-float-y");
  if(!els.length) return;

  els.forEach(el => {
    gsap.to(el, {
      y: '-1.5rem',
      duration: 1,
      repeat: -1,
      yoyo: true,
      ease: "sine.inOut",
    });
  });
}

function initGsCardRotate() {
  const els = gsap.utils.toArray(".gs-card-rotate3d");
  if (!els.length) return;

  els.forEach(el => {
    gsap.fromTo(el,
      { rotateY:60 },
      {
        rotateY:-60,
        duration: 2,
        ease: "sine.inOut",
        repeat: -1,
        yoyo: true,
      }
    );
  });
}
function initGsCardRotateClockwise() {
  const els = gsap.utils.toArray(".gs-card-rotate-clockwise");
  if (!els.length) return;
  els.forEach(el => {
    // 先杀掉该元素所有控制rotate的动画，彻底清理
    gsap.killTweensOf(el, "rotate");
    el._rotateTween = gsap.to(el,
      {
        rotate: "+=360",   // 相对旋转，推荐写法
        duration: 4,
        ease: "none",
        repeat: -1,
      }
    );
  });
}




function initGsScrollReveal() {
  const els = gsap.utils.toArray(".gs-scroll-reveal");
  if (!els.length) return;
  els.forEach(el => {
    // clearProps:"transform" 清除GSAP捕获到的transform，只保留opacity和y
    gsap.set(el, { opacity: 0, y: 40, clearProps: "transform" });
    gsap.fromTo(el,
      { opacity: 0, y: 40 },
      {
        opacity: 1,
        y: 0,
        duration: 0.8,
        ease: "power2.out",
        scrollTrigger: {
          trigger: el,
          start: "top 60%",
          end: "top 0",
          toggleActions: "play none none reverse",
          markers: false,
          scroller: document.body,
          preventOverlaps: true,
        }
      }
    );
  });
}


// 页面加载执行
initGsScrollReveal();


function initGsScaleLoop() {
  const els = gsap.utils.toArray(".gs-scale-loop");
  if (!els.length) return;

  els.forEach(el => {
    gsap.to(el, {
      scale: 1.15,        // 放大到1.15倍
      duration: 1.8,
      ease: "sine.inOut",
      repeat: -1,         // 无限循环
      yoyo: true          // 播放完反向还原
    });
  });
}

function initGsScaleLoopBoom() {
  const els = gsap.utils.toArray(".gs-scale-loop-boom");
  if (!els.length) return;
  els.forEach((el) => {
    el._animTl = null;
    el._observer = null; // 保存observer实例，方便释放
    el._animTl = gsap.timeline({
      paused: true,
      onComplete: () => {
        // ✅ 动画执行完成回调：释放动画引用，保留元素状态
        el._animTl.kill();
        el._animTl = null;
      }
    });
    el._animTl
      // 初始爆炸状态：保留 xPercent/yPercent=-50%（对应 translate(-50%,-50%)）
      .set(el, {
        scaleX: 5,
        scaleY: 5,
        xPercent: -50,
        yPercent: -50,
        zIndex: 100
      })
      .to(el, {
        scaleX: 1,
        scaleY: 1,
        xPercent: -50,
        yPercent: -50,
        zIndex: 20,
        duration: 1,
        ease: "back.out(1.7)"
      });
    // class监听
    const observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.attributeName === "class") {
          const hasClass = el.classList.contains("gs-scale-loop-boom");
          if (hasClass) {
            // 重新播放前，如果旧动画存在，先清理
            if(el._animTl){
              el._animTl.kill();
            }
            el._animTl = gsap.timeline({
              paused:true,
              onComplete:()=>{
                el._animTl.kill();
                el._animTl = null;
              }
            })
            el._animTl
              .set(el, {
                scaleX: 5,
                scaleY: 5,
                xPercent: -50,
                yPercent: -50,
                zIndex: 100
              })
              .to(el, {
                scaleX: 1,
                scaleY: 1,
                xPercent: -50,
                yPercent: -50,
                zIndex: 20,
                duration: 1,
                ease: "back.out(1.7)"
              });
            el._animTl.restart();
          } else {
            if(el._animTl) {
              el._animTl.kill();
              el._animTl = null;
            }
            // 移除类的时候重置：依旧保持居中 translate(-50%,-50%)
            gsap.set(el, {
              scaleX: 1,
              scaleY: 1,
              xPercent: -50,
              yPercent: -50,
              zIndex:1
            });
            observer.disconnect();
            el._observer = null;
          }
          break;
        }
      }
    });
    el._observer = observer;
    observer.observe(el, { attributes: true });
    // 页面初始化播放
    if (el.classList.contains("gs-scale-loop-boom")) {
      el._animTl.play();
    }
  });
}







//<!-- 独立模式 -->
//<div data-animation-text="scrub-word">独立文字块</div>
//
//<!-- A组：在A1上配置本组参数 -->
//<div
//  data-animation-text="scrub-word-A1"
//  data-group-end="+=450%"
//  data-group-gap="0.4"
//>
//  A组第一条
//</div>
//<div data-animation-text="scrub-word-A2">A组第二条</div>
//<div data-animation-text="scrub-word-A3">A组第三条</div>
//
//<!-- B组：使用默认 end +=320%，gap 0.25 -->
//<div data-animation-text="scrub-word-B1">B组第一条</div>
//<div data-animation-text="scrub-word-B2">B组第二条</div>
const scrubWordAnim = () => {
  const allEls = gsap.utils.toArray("[data-animation-text]");
  if (!allEls.length) return;

  const getCSSVariable = (variableName, fallback = "#434443") => {
    return (
      getComputedStyle(document.documentElement).getPropertyValue(variableName) || fallback
    );
  };
  const BRAND_COLOR = getCSSVariable("--swatch--brand-500", "#FF8300");
  const TEXT_COLOR = getCSSVariable("--swatch--brand-text-heading", "#fff");
  const FADED_COLOR = "#434443";

  const groupMap = {};
  const standaloneList = [];

  allEls.forEach((el) => {
    const animVal = el.dataset.animationText.trim();
    const groupReg = /^scrub-word-([A-Za-z]+)(\d+)$/;
    const match = animVal.match(groupReg);

    if (match) {
      const groupKey = match[1];
      const sortIndex = parseInt(match[2], 10);
      if (!groupMap[groupKey]) groupMap[groupKey] = [];
      groupMap[groupKey].push({
        el,
        sortIndex
      });
    } else if (animVal === "scrub-word") {
      standaloneList.push(el);
    }
  });

  // ------------------------------
  // 模式1：独立模式 scrub‑word（原版逻辑）
  // ------------------------------
  standaloneList.forEach((text) => {
    const split = new SplitText(text, {
      type: "words, chars",
      wordsClass: "word",
      charsClass: "char",
    });
    const skipChars = [];
    split.words.forEach((wordEl) => {
      const fixedColor = wordEl.dataset.fixedColor;
      if (fixedColor) {
        gsap.set(wordEl, { color: fixedColor });
        wordEl.querySelectorAll(".char").forEach((char) => {
          skipChars.push(char);
          char.style.setProperty("color", fixedColor, "important");
        });
      }
    });
    const animChars = split.chars.filter((c) => !skipChars.includes(c));

    ScrollTrigger.create({
      trigger: text,
      onUnmount: () => split.revert(),
    });

    gsap.timeline({
      scrollTrigger: {
        trigger: text,
        start: "top 50%",
        end: "100% 50%",
        scrub: true,
      },
      defaults: { ease: "power3" },
    })
      .set(animChars, { color: FADED_COLOR })
      .to(animChars, {
        keyframes: [
          { color: FADED_COLOR, duration: 0.2 },
          { color: BRAND_COLOR, duration: 0.2 },
          { color: TEXT_COLOR, duration: 0.4 },
        ],
        duration: 0.8,
        stagger: { each: 0.01 },
      });
  });

  // ------------------------------
  // 模式2：分组关联模式，支持 data‑group‑end / data‑group‑gap
  // ------------------------------
  Object.values(groupMap).forEach((groupItems) => {
    // 按后缀数字升序排序
    groupItems.sort((a, b) => a.sortIndex - b.sortIndex);

    // 本组第一个DOM，读取自定义配置
    const groupRootEl = groupItems[0].el;
    // 默认值
    const DEFAULT_GROUP_END = "+=320%";
    const DEFAULT_GROUP_GAP = 0.25;

    // 读取自定义属性
    const customGroupEnd = groupRootEl.dataset.groupEnd || DEFAULT_GROUP_END;
    const customGroupGap = parseFloat(groupRootEl.dataset.groupGap) || DEFAULT_GROUP_GAP;

    const blockList = [];
    groupItems.forEach(({ el }) => {
      const split = new SplitText(el, {
        type: "words, chars",
        wordsClass: "word",
        charsClass: "char",
      });
      const skipChars = [];
      split.words.forEach((wordEl) => {
        const fixedColor = wordEl.dataset.fixedColor;
        if (fixedColor) {
          gsap.set(wordEl, { color: fixedColor });
          wordEl.querySelectorAll(".char").forEach((char) => {
            skipChars.push(char);
            char.style.setProperty("color", fixedColor, "important");
          });
        }
      });
      const animChars = split.chars.filter((c) => !skipChars.includes(c));
      blockList.push({ el, split, animChars });

      ScrollTrigger.create({
        trigger: el,
        onUnmount: () => split.revert(),
      });
    });

    const masterTl = gsap.timeline({
      scrollTrigger: {
        trigger: blockList[0].el,
        start: "top 60%",
        end: customGroupEnd,
        scrub: true,
        // markers: true,
      },
      defaults: { ease: "power3" },
    });

    blockList.forEach((block, idx) => {
      const { animChars } = block;
      masterTl
        .set(animChars, { color: FADED_COLOR })
        .to(animChars, {
          keyframes: [
            { color: FADED_COLOR, duration: 0.2 },
            { color: BRAND_COLOR, duration: 0.2 },
            { color: TEXT_COLOR, duration: 0.4 },
          ],
          duration: 0.8,
          stagger: { each: 0.01 },
        });

      // 最后一块不再追加间隙
      if (idx !== blockList.length - 1) {
        masterTl.add(null, `+=${customGroupGap}`);
      }
    });
  });
};


function initGsScrollPopY() {
  const els = gsap.utils.toArray(".gs-scroll-pop-y");
  if (!els.length) return;

  const getOffsetY = () => window.innerWidth > 750 ? "-2rem" : "-1rem";

  els.forEach((el) => {
    const children = Array.from(el.children);

    // 父元素初始状态
    gsap.set(el, {
      y: getOffsetY(),
      opacity: 0
    });

    // 子元素初始状态
    if(children.length > 0){
      gsap.set(children, {
        y: getOffsetY(),
        opacity: 0
      });
    }

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: el,
        start: "top 40%",
        end: "top 0%",
        toggleActions: "play none none reset",
        //markers: true
      }
    });

    // 先播放父元素弹出
    tl.to(el, {
      y: 0,
      opacity: 1,
      duration: 0.7,
      ease: "power2.out"
    });

    // 如果存在直接子元素，父动画结束后子元素依次弹出
    if(children.length > 0){
      tl.to(children, {
        y: 0,
        opacity: 1,
        stagger: 0.2,
        duration: 0.7,
        ease: "power2.out"
      }, "-=0.35"); // 和父动画部分重叠，视觉更流畅
    }
  });

  // resize 更新初始偏移，仅非激活状态
  window.addEventListener("resize", () => {
    els.forEach((el) => {
      const children = Array.from(el.children);
      const st = ScrollTrigger.getById(el);
      if (!st || !st.isActive) {
        gsap.set(el, { y: getOffsetY() });
        if(children.length>0){
          gsap.set(children, { y: getOffsetY() });
        }
      }
    });
  });
}


/**
 * 获取当前可见的 br‑source（过滤掉 display:none 的）
 */
function getActiveBrSource(wrapEl){
  const sources = Array.from(wrapEl.querySelectorAll(".br-source"));
  for(let el of sources){
    const st = getComputedStyle(el);
    if(st.display !== "none"){
      return el;
    }
  }
  return null;
}

const scrubLineBrAnim = () => {
  const blocks = gsap.utils.toArray("[data-animation-text='scrub-line-br']");
  if (blocks.length === 0) return;

  blocks.forEach((block) => {
    // 清除旧DOM、旧ScrollTrigger实例
    block.querySelectorAll(".scrub-br__line").forEach((el) => el.remove());
    if (block._scrubBrST) {
      block._scrubBrST.kill();
      block._scrubBrST = null;
    }

    // ✅拿到当前屏幕下真正显示的br‑source（desktop_only / mobile_only自动区分）
    const source = getActiveBrSource(block);
    if (!source) return;

    const colorBefore = block.dataset.colorBefore;
    const colorAfter = block.dataset.colorAfter;

    const rootStyle = getComputedStyle(document.documentElement);
    const colorBeforeVal = colorBefore ?? rootStyle.getPropertyValue('--color-before').trim();
    const colorAfterVal = colorAfter ?? rootStyle.getPropertyValue('--color-after').trim();

    // 读取当前生效source的字体样式
    const computed = getComputedStyle(source);
    const sourceFontSize = computed.fontSize;
    const sourceFontWeight = computed.fontWeight;
    const sourceLineHeight = computed.lineHeight;

    const raw = source.innerHTML;
    const lineTexts = raw
      .split(/<br\s*\/?>/i)
      .map((t) => t.trim())
      .filter(Boolean);

    if (lineTexts.length === 0) return;

    const renderLines = [];
    lineTexts.forEach((txt) => {
      const div = document.createElement("div");
      div.className = "scrub-br__line";
      div.textContent = txt;

      div.style.fontSize = sourceFontSize;
      div.style.fontWeight = sourceFontWeight;
      div.style.lineHeight = sourceLineHeight;

      // JS直接拼接渐变，规避css‑var+background‑image浏览器bug
      div.style.backgroundImage = `
        linear-gradient(90deg, ${colorAfterVal}, ${colorAfterVal}),
        linear-gradient(90deg, ${colorBeforeVal}, ${colorBeforeVal})
      `;

      block.appendChild(div);
      renderLines.push(div);
    });

    const totalLine = renderLines.length;

    const st = ScrollTrigger.create({
      trigger: block,
      start: "top 75%",
      end: "bottom 25%",
      scrub: 1,
      // markers:true,
      onUpdate: (self) => {
        const p = self.progress;
        renderLines.forEach((lineEl, idx) => {
          const lineStart = idx / totalLine;
          const lineEnd = (idx + 1) / totalLine;
          let animSize;
          if (p <= lineStart) animSize = 0;
          else if (p >= lineEnd) animSize = 100;
          else {
            const localP = (p - lineStart) / (lineEnd - lineStart);
            animSize = localP * 100;
          }
          lineEl.style.backgroundSize = `${animSize}% 100%, 100% 100%`;
        });
      },
      onUnmount: () => {
        renderLines.forEach((el) => el.remove());
      },
    });
    block._scrubBrST = st;
  });
};


// resize时重新渲染，桌面↔移动端切换自动更新换行与文本
let resizeTimer;
window.addEventListener('resize', ()=>{
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(()=>{
    scrubLineBrAnim();
  }, 150);
})






// 兼容DOMReady工具函数，规避 addEventListener 链式解析bug
function domReady(callback) {
  const doc = window.document;
  if (doc.readyState !== "loading") {
    callback();
  } else {
    doc.addEventListener("DOMContentLoaded", callback, false);
  }
}
// 初始化上下浮动
domReady(function(){
  initGsFloatY();
  initGsCardRotate();
  initGsScaleLoop();
  scrubWordAnim();
  initGsScrollPopY();
  scrubLineBrAnim();
  initGsScaleLoopBoom();
  initGsCardRotateClockwise();
  initGsScrollReveal();
});


document.querySelectorAll('[data-theme-key]').forEach(el => {
  const key = el.dataset.themeKey;
  if(window.THEME_MENUS && window.THEME_MENUS[key]){
    el.href = window.THEME_MENUS[key];
  }else{
    el.href = '/'; //兜底
  }
});
